export default function convertDecimalForChart(decimal) {
  if (decimal === 0) return "—";
  if (decimal === null) return null;
  const asString = decimal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");

  const asSplitedString = asString.split(".");

  const secondPart = asSplitedString[1];
  if (secondPart == null) return asString + ".00";

  if (secondPart.length > 1) {
    return asString;
  } else {
    return asString + "0";
  }
}
